"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SsnInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MaskedTextInput = _interopRequireDefault(require("../MaskedTextInput"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SsnInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SsnInput, _Component);

  var _super = _createSuper(SsnInput);

  function SsnInput() {
    var _this;

    (0, _classCallCheck2.default)(this, SsnInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          label = _this$props.label,
          helperText = _this$props.helperText,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          required = _this$props.required,
          value = _this$props.value,
          className = _this$props.className,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["id", "disabled", "error", "errorMessage", "label", "helperText", "placeholder", "onChange", "required", "value", "className"]);
      return /*#__PURE__*/_react.default.createElement(_MaskedTextInput.default, (0, _extends2.default)({
        id: id,
        className: "prmbl-ssnInput ".concat(className),
        disabled: disabled,
        error: error,
        errorMessage: errorMessage,
        label: label,
        helperText: helperText,
        placeholder: placeholder,
        onChange: onChange,
        required: required,
        value: value,
        maskTemplate: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
      }, other));
    });
    return _this;
  }

  return SsnInput;
}(_react.Component);

exports.SsnInput = SsnInput;
(0, _defineProperty2.default)(SsnInput, "propTypes", {
  /**
   * The `html` id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * If `true` the component will be rendered as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * The message to display when `error` is `true`.
   */
  errorMessage: _propTypes.default.string,

  /**
   * The label for the component
   */
  label: _propTypes.default.string,

  /**
   * The helper text to be displayed with the component
   */
  helperText: _propTypes.default.string,

  /**
   * The placeholder text for the component
   */
  placeholder: _propTypes.default.string,

  /**
   * The onChange callback called when text is entered. - Value is accessible in the originating event; event.target.value.
   *
   * Signature: `function(event) => void`
   * event: The originating event.
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, marks the field as required
   */
  required: _propTypes.default.bool,

  /**
   * The value of the text field in the input component
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(SsnInput, "defaultProps", {
  className: ""
});
var _default = SsnInput;
exports.default = _default;